
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 90 90","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_28559_108667)","stroke-width":"3","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M44.998 61.875c15.533 0 28.125-12.592 28.125-28.125S60.531 5.625 44.998 5.625 16.873 18.217 16.873 33.75s12.592 28.125 28.125 28.125z","stroke":"#fff"}}),_c('path',{attrs:{"d":"M44.998 50.625c9.32 0 16.875-7.555 16.875-16.875s-7.555-16.875-16.875-16.875S28.123 24.43 28.123 33.75s7.555 16.875 16.875 16.875z","stroke":"currentColor"}}),_c('path',{attrs:{"d":"M61.875 56.248v28.127l-16.877-8.437-16.873 8.437V56.251","stroke":"#fff"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_28559_108667"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h90v90H0z"}})])])])
          )
        }
      }
    